import { render, staticRenderFns } from "./SalesAssessmentsAdmin.vue?vue&type=template&id=52336fe6&scoped=true"
import script from "./SalesAssessmentsAdmin.vue?vue&type=script&lang=js"
export * from "./SalesAssessmentsAdmin.vue?vue&type=script&lang=js"
import style0 from "./SalesAssessmentsAdmin.vue?vue&type=style&index=0&id=52336fe6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52336fe6",
  null
  
)

export default component.exports